<template>
  <div class="replenish-info" v-if="replenishInfo">
    <div>
      <div>
        <span style="font-size: 16px; font-weight: bolder; line-height: 35px">
          编号:{{ replenishInfo.guid }}
        </span>
      </div>
      <div>
        <span> 当前状态: </span>
        <span
          class="replenish-status"
          :style="{
            backgroundColor: getStatusColor(),
            color: '#ffffff',
          }"
          v-if="getStatusLabel()"
        >
          {{ getStatusLabel() }}
        </span>
        <span
          class="replenish-status"
          :style="{
            backgroundColor: getInboundColor(),
            color: '#ffffff',
          }"
          v-if="getInboundLabel()"
        >
          {{ getInboundLabel() }}
        </span>
        <span
          class="replenish-status"
          :style="{
            backgroundColor: getOutboundColor(),
            color: '#ffffff',
          }"
          v-if="getOutboundLabel()"
        >
          {{ getOutboundLabel() }}
        </span>
      </div>
      <div v-if="replenishInfo.storehouseInfo">
        供货仓库:
        <span> {{ replenishInfo.storehouseInfo.name }} </span>
      </div>
      <div v-if="replenishInfo.storeInfo">
        要货门店:
        <span> {{ replenishInfo.storeInfo.name }} </span>
      </div>
      <div class="replenish-flex">
        <span class="desc-item" v-if="replenishInfo.purchaseOrderRemark">
          <span>
            采购信息:
            <span>
              {{ replenishInfo.purchaseOrderRemark }}
            </span>
          </span>
        </span>
        <span class="desc-item" v-if="replenishInfo.createTime > 0">
          创建时间:
          <span>
            {{ new Date(replenishInfo.createTime).format("YYYY-MM-dd hh:mm:ss") }}
          </span>
        </span>
        <span class="desc-item" v-if="replenishInfo.demandGuid">
          要货单号:
          <span> {{ replenishInfo.demandGuid }} </span>
        </span>
        <span class="desc-item" v-if="getTypeLabel()">
          补货方式:
          <span>{{ getTypeLabel() }} </span>
        </span>
        <span class="desc-item" v-if="replenishInfo.purchaseGoodsCount > 0">
          供货数量:
          <span>
            {{ replenishInfo.purchaseGoodsCount }}
          </span>
          <span> 份商品 </span>
        </span>
        <span class="desc-item" v-if="replenishInfo.purchaseAmount > 0">
          供货金额:
          <span>
            {{ replenishInfo.purchaseAmount }}
          </span>
          <span>元</span>
        </span>
        <span class="desc-item" v-if="showCost && replenishInfo.freightCost > 0">
          运费成本:
          <span>
            {{ replenishInfo.freightCost }}
          </span>
          <span>元</span>
        </span>
        <span class="desc-item" v-if="replenishInfo.freightAmount > 0">
          运费金额:
          <span>
            {{ replenishInfo.freightAmount }}
          </span>
          <span>元</span>
        </span>
        <span class="desc-item" v-if="replenishInfo.discountAmount > 0">
          优惠金额:
          <span>
            {{ replenishInfo.discountAmount }}
          </span>
          <span>元</span>
        </span>
        <span class="desc-item" v-if="showCost && replenishInfo.totalCost > 0">
          合计成本:
          <span>
            {{ replenishInfo.totalCost }}
          </span>
          <span>元</span>
        </span>
        <span class="desc-item" v-if="replenishInfo.totalAmount > 0">
          合计金额:
          <span>
            {{ replenishInfo.totalAmount }}
          </span>
          <span>元</span>
        </span>
        <span class="desc-item" v-if="replenishInfo.handledBy">
          经手人员:
          <span>{{ replenishInfo.handledBy }}</span>
        </span>
      </div>
    </div>
    <div v-if="replenishInfo.purchaseTrackingNumber">
      <div class="wordwrap">
        快递单号:
        <span>
          {{ replenishInfo.purchaseTrackingNumber }}
        </span>
      </div>
    </div>
    <div label="备注信息" v-if="replenishInfo.optRemark">
      <div class="wordwrap">
        备注信息:
        <span class="replenish-remark">{{ replenishInfo.optRemark }}</span>
      </div>
    </div>
    <div v-if="replenishInfo.purchaseGoodsSnapshot">
      <div class="wordwrap">
        <span class="replenish-goods"> {{ replenishInfo.purchaseGoodsSnapshot }} </span>
        <span v-if="replenishInfo.purchaseRow > 5">
          （共{{ replenishInfo.purchaseRow }}个商品，最多显示前5个商品）
        </span>
        <span v-else> （共{{ replenishInfo.purchaseRow }}个商品） </span>
      </div>
    </div>
    <div
      class="replenish-item-list"
      v-if="showCount && replenishInfo.inventoryInfoCount > 0"
    >
      <span
        @click="inventoryListClick"
        style="font-size: 14px; cursor: pointer; color: #909399; margin-right: 10px"
        v-if="replenishInfo.inventoryInfoCount > 0"
      >
        共{{ replenishInfo.inventoryInfoCount }}条库存记录
      </span>
    </div>
  </div>
</template>

<style lang="less" scoped>
.replenish-remark {
  font-weight: bolder;
  line-height: 30px;
  color: #000000;
}

.replenish-flex {
  .desc-item {
    margin-right: 20px;
  }
}

.replenish-goods {
  color: #333;
}

.replenish-item-list {
  background: #fafafa;
  margin-top: 10px;
  padding: 10px;

  .item-info {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-top: 20px;
    margin-bottom: 20px;
    font-size: 14px;
  }

  .item-count {
    font-size: 14px;
  }
}

.replenish-status {
  width: auto;
  padding: 2px 5px;
  background-color: #ffffff;
  font-weight: 400;
  margin-right: 5px;
  border-radius: 5px;
  font-size: 14px;
  color: #5c5c5c;
}
</style>

<script>
export default {
  props: {
    showCount: {
      type: Boolean,
      default: false,
    },
    showCost: {
      type: Boolean,
      default: false,
    },
    replenishInfo: {
      type: Object,
    },
  },
  methods: {
    inventoryListClick() {
      this.$emit("inventoryListClick", this.replenishInfo);
    },
    getStatusColor() {
      if (this.replenishInfo.optStatus == 0) {
        return "#E6A23C";
      } else if (this.replenishInfo.optStatus == 1) {
        return "#6F88A1";
      } else if (this.replenishInfo.optStatus == 11) {
        return "#6F88A1";
      } else if (this.replenishInfo.optStatus == 2) {
        return "#6F88A1";
      } else if (this.replenishInfo.optStatus == 3) {
        return "#67C23A";
      } else if (this.replenishInfo.optStatus == 4) {
        return "#F56C6C";
      }
      return "#919191";
    },
    getStatusLabel() {
      if (this.replenishInfo.optStatus == 0) {
        return "等待确认";
      } else if (this.replenishInfo.optStatus == 1) {
        return "等待出库";
      } else if (this.replenishInfo.optStatus == 11) {
        return "等待采购";
      } else if (this.replenishInfo.optStatus == 2) {
        return "等待入库";
      } else if (this.replenishInfo.optStatus == 3) {
        return "已完成的";
      } else if (this.replenishInfo.optStatus == 4) {
        return "已关闭的";
      }
      return "";
    },
    getTypeLabel() {
      if (!this.replenishInfo) {
        return "";
      }
      if (this.replenishInfo.replenishType == "purchase_purchase") {
        return "门店直采";
      } else if (this.replenishInfo.replenishType == "replenish_purchase") {
        return "仓库统采";
      } else if (this.replenishInfo.replenishType == "replenish_transfer") {
        return "仓库调货";
      }
      return replenishInfo.replenishType;
    },
    getInboundLabel() {
      if (
        this.replenishInfo &&
        this.replenishInfo.optCancel == 0 &&
        this.replenishInfo.optInbound == 1
      ) {
        return "部分入库";
      }
      return "";
    },
    getInboundColor() {
      return "#909399";
    },
    getOutboundLabel() {
      if (
        this.replenishInfo &&
        this.replenishInfo.optCancel == 0 &&
        this.replenishInfo.optOutbound == 1
      ) {
        return "部分出库";
      }
      return "";
    },
    getOutboundColor() {
      return "#909399";
    },
  },
};
</script>
